var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.adventCalendarIFrameContentExperienceV1 = {
    attach: function (context) {
      const $modules = $('.js-advent-calendar-iframe-content-experience--v1', context);
      const desktopWidth = 840;
      $modules.each(function() {
        const $module = $(this);
        const $iframeWrapper = $(this).find('.js-advent-calendar-iframe');
        const $iframe = $('iframe', $iframeWrapper);
        const $column = $(this).find('.js-advent-calendar-sticky-wrapper');
        const calculateOffsets = () => {
          if ($(window).width() >= desktopWidth) {
            $iframeWrapper.css({
              'margin-top': (-1 * $column.height()),
            });
          } else {
            $iframeWrapper.css({
              'margin-top': 0,
            });
          }
        };

        $iframe.on('iframe.message', function(event, message) {
          const action = message['_elc_action'];
          switch(action) {
            case 'scroll.lock':
            case 'scroll.unlock':
              calculateOffsets();
              if (action === 'scroll.lock') {
                const maxDocumentScroll = $module.offset().top + message.height + message.offset.top;
                $('html, body', context).scrollTop($module.offset().top);
                $('body', context).css({
                  height: maxDocumentScroll,
                  overflow: 'hidden',
                });
              } else {
                $('body', context).css({
                  height: '',
                  overflow: '',
                });
              }
          }
        });
        $(window).on('resize', _.throttle(function(event) {
          calculateOffsets();
        }, 100));
        calculateOffsets();
      });
    }
  };
})(jQuery);
